let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3opZo")).then(() => parcelRequire('2kmFP'));